module.exports = __webpack_public_path__ + "static/media/2nd-spec.98de0ed5.jpg";